import { render, staticRenderFns } from "./NewBtn.vue?vue&type=template&id=363a6952&scoped=true&"
import script from "./NewBtn.vue?vue&type=script&lang=js&"
export * from "./NewBtn.vue?vue&type=script&lang=js&"
import style0 from "./NewBtn.vue?vue&type=style&index=0&id=363a6952&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363a6952",
  null
  
)

export default component.exports